<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Beneficiárias Coligadas</h1>                
                <button mat-flat-button color="primary" [routerLink]="['nova']">ADD COLIGADA</button>
            </div>
            <generate-table [dataSource]="dataSource" [columns]="columns" [loading]="loading"></generate-table>
        </mat-card-content>
    </mat-card>
</div>